<template>
  <div class="content has-text-centered">
    <ul
      class="quickMenu"
      :class="{'quickMenu-direction-rtl': Language == 'fa' || Language == 'ar'}"
    >
      <li>
        <router-link :to="'/' + Language + '/finance/deposit'">
          <div class="quick-icon">
            <img src="../../assets/img/icons/quick-menu/deposit.svg" />
          </div>
          <h4>{{$t('deposit_funds').tTitle()}}</h4>
        </router-link>
      </li>
      <li>
        <router-link :to="'/' + Language + '/finance/withdraw'">
          <div class="quick-icon">
            <img src="../../assets/img/icons/quick-menu/withdraw.svg" />
          </div>
          <h4>{{$t('withdraw_funds').tTitle()}}</h4>
        </router-link>
      </li>
      <li>
        <router-link :to="'/' + Language + '/finance/internal-transfer'">
          <div class="quick-icon">
            <img src="../../assets/img/icons/quick-menu/internal-transfer.svg" />
          </div>
          <h4>{{$t('internal_transfer').tTitle()}}</h4>
        </router-link>
      </li>
      <li>
        <router-link :to="'/' + Language + '/finance/payment-history'">
          <div class="quick-icon">
            <img src="../../assets/img/icons/quick-menu/payment-history.svg" />
          </div>
          <h4>{{$t('payment_history').tTitle()}}</h4>
        </router-link>
      </li>
      <li>
        <router-link :to="'/' + Language + '/finance/my-cards'">
          <div class="quick-icon">
            <img src="../../assets/img/icons/quick-menu/mycards.svg" />
          </div>
          <h4>{{$t('my_cards').tTitle()}}</h4>
        </router-link>
      </li>
      <li v-if="IsLive && BonusConfig.depositBonus.enabled">
        <router-link :to="'/' + Language + '/finance/my-bonuses'">
          <div class="quick-icon"><img src="../../assets/img/icons/quick-menu/bonus.svg"></div>
          <h4>{{$t('my_bonuses').tTitle()}}</h4>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      Language: 'language/code',
      IsLive: 'user/isLive',
      BonusConfig: 'bonusconfig/all',
    }),
  },
  mounted() {},
}
</script>

<style lang="scss" >
// @import "../assets/css/variables";
</style>



// WEBPACK FOOTER //
// FinanceMenu.vue?aa27a1ac